export const CONNECTIONS_BASE_PATH = '/kraken-multi';
export const CONNECTIONS_RECOVERY_PATH = '/kraken-multi/recovery';
export const CONNECTIONS_INSTALL_PATH = '/kraken-multi/install';

export const isConnectionsPath = (pathname = '') => pathname.startsWith(CONNECTIONS_BASE_PATH);

export const getConnectionsSection = (pathname = '') => {
  if (pathname.startsWith(CONNECTIONS_RECOVERY_PATH)) {
    return 'recovery';
  }
  if (pathname.startsWith(CONNECTIONS_INSTALL_PATH)) {
    return 'install';
  }
  return 'list';
};
